export const useRateLimiter = () => {
  const interval = ref()
  const { limit, limited, remaining, retryAt, secondsLeft } = storeToRefs(useRateLimiterStore())

  onNuxtReady(() => {
    clearInterval(interval.value)
    secondsLeft.value = Math.round(retryAt.value - Date.now() / 1000)
    interval.value = setInterval(() => {
      secondsLeft.value = Math.round(retryAt.value - Date.now() / 1000)
    }, 1000)
  })

  return { limit, limited, remaining, retryAt, secondsLeft }
}
